var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuantifyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66667 8.66683C3.03486 8.66683 3.33333 8.96531 3.33333 9.3335V14.0002C3.33333 14.3684 3.03486 14.6668 2.66667 14.6668C2.29848 14.6668 2 14.3684 2 14.0002V9.3335C2 8.96531 2.29848 8.66683 2.66667 8.66683Z",
    fill: "#FB7B33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66667 1.3335C3.03486 1.3335 3.33333 1.63197 3.33333 2.00016V6.66683C3.33333 7.03502 3.03486 7.3335 2.66667 7.3335C2.29848 7.3335 2 7.03502 2 6.66683V2.00016C2 1.63197 2.29848 1.3335 2.66667 1.3335Z",
    fill: "#FB7B33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7.3335C8.36819 7.3335 8.66667 7.63197 8.66667 8.00016V14.0002C8.66667 14.3684 8.36819 14.6668 8 14.6668C7.63181 14.6668 7.33333 14.3684 7.33333 14.0002V8.00016C7.33333 7.63197 7.63181 7.3335 8 7.3335Z",
    fill: "#FB7B33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.3335C8.36819 1.3335 8.66667 1.63197 8.66667 2.00016V5.3335C8.66667 5.70169 8.36819 6.00016 8 6.00016C7.63181 6.00016 7.33333 5.70169 7.33333 5.3335V2.00016C7.33333 1.63197 7.63181 1.3335 8 1.3335Z",
    fill: "#FB7B33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 10.0002C13.7015 10.0002 14 10.2986 14 10.6668V14.0002C14 14.3684 13.7015 14.6668 13.3333 14.6668C12.9651 14.6668 12.6667 14.3684 12.6667 14.0002V10.6668C12.6667 10.2986 12.9651 10.0002 13.3333 10.0002Z",
    fill: "#FB7B33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 1.3335C13.7015 1.3335 14 1.63197 14 2.00016V8.00016C14 8.36835 13.7015 8.66683 13.3333 8.66683C12.9651 8.66683 12.6667 8.36835 12.6667 8.00016V2.00016C12.6667 1.63197 12.9651 1.3335 13.3333 1.3335Z",
    fill: "#FB7B33"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.3335C0 8.96531 0.298477 8.66683 0.666667 8.66683H4.66667C5.03486 8.66683 5.33333 8.96531 5.33333 9.3335C5.33333 9.70169 5.03486 10.0002 4.66667 10.0002H0.666667C0.298477 10.0002 0 9.70169 0 9.3335Z",
    fill: "#FB7B33"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33333 5.3335C5.33333 4.96531 5.63181 4.66683 6 4.66683H10C10.3682 4.66683 10.6667 4.96531 10.6667 5.3335C10.6667 5.70169 10.3682 6.00016 10 6.00016H6C5.63181 6.00016 5.33333 5.70169 5.33333 5.3335Z",
    fill: "#FB7B33"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 10.6668C10.6667 10.2986 10.9651 10.0002 11.3333 10.0002H15.3333C15.7015 10.0002 16 10.2986 16 10.6668C16 11.035 15.7015 11.3335 15.3333 11.3335H11.3333C10.9651 11.3335 10.6667 11.035 10.6667 10.6668Z",
    fill: "#FB7B33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantifyIcon);
export default __webpack_public_path__ + "static/media/quantify-icon.f1abc702657b738062d3c62352d366ce.svg";
export { ForwardRef as ReactComponent };